/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderFile
 */
export interface ProviderFile {
    /**
     * 
     * @type {string}
     * @memberof ProviderFile
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderFile
     */
    name: string;
    /**
     * Download link for this specific file version.
     * @type {string}
     * @memberof ProviderFile
     */
    downloadLink?: string;
}

/**
 * Check if a given object implements the ProviderFile interface.
 */
export function instanceOfProviderFile(value: object): value is ProviderFile {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ProviderFileFromJSON(json: any): ProviderFile {
    return ProviderFileFromJSONTyped(json, false);
}

export function ProviderFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderFile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'downloadLink': json['downloadLink'] == null ? undefined : json['downloadLink'],
    };
}

export function ProviderFileToJSON(value?: ProviderFile | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'downloadLink': value['downloadLink'],
    };
}

